import * as React from "react"
import { useMemo, useState ,useCallback,useEffect} from "react"
import { useTranslation } from "react-i18next"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import Form from "@bappweb/form"
import Button from "@bappweb/button"
import { Sizes, useDeviceSize } from "@bappweb/provider"
import Page from "@components/globalmodules/page"
import BigLogoAkbank from "@components/globalmodules/logo/index-bigLogo"
import "./style.scss"
import "../styleBase.scss"
import TextField from "@bappweb/textfield"
import { required } from "@bappweb/utils"
import { ChangePasswordService } from "@config/axios/changePasswordService"
import { useHistory } from "react-router-dom"
import { sendSMSOTPVerify } from "@config/axios/sendSMSOTPVerify"
import { SendSMSOTPService } from "@config/axios/sendSMSOTPService"
import Link from "@bappweb/link"
import { CompositeOTPControl } from "@config/axios/compositeOTPControl"
import { CaptchaCallService } from "@config/axios/captchaCallService"


let changePswRespData: { ldapReturnCode: string, ldapReturnMessage: string } = {
  ldapReturnCode: "",
  ldapReturnMessage: ""
}
let smsOtpVerifyRespData: { returnCode: number, returnInfo: string } = {
  returnCode: -1,
  returnInfo: ""
}


let responseSMSData: { retCode: number, retMsg: string, refId: string } = {
  retCode: 0,
  retMsg: "",
  refId: ""
}

const SftpChangePasswordSmsOtp = (props) => {
  const { t } = useTranslation()
  const size = useDeviceSize()
  const history = useHistory()

  const [captchaResp, setCaptchaResp] = useState({ id: "" });
  const [base64Image, setbase64Image] = React.useState("");
  const [changeServiceRetCodes, setChangeSrvRetCode] = useState("");
  const [changeServiceRetMsg, setChangeSrvRetMsg] = useState("");
  const [otp1, setotp1] = useState("");
  const [otp2, setotp2] = useState("");
  const [otp3, setotp3] = useState("");
  const [otp4, setotp4] = useState("");
  const [otp5, setotp5] = useState("");
  const [otp6, setotp6] = useState("");
  const [retCode, setRetCode] = useState(-1);
  const [returnInfo, setreturnInfo] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [captchafield, setcaptchafield] = React.useState("");

  let passRefId = props.location.state.passData.refId;
  let passUserName = props.location.state.passData.userName;
  let passCurrentPsw = props.location.state.passData.currentPsw;
  let passNewPsw = props.location.state.passData.newPsw;
  let passNewPswAgain = props.location.state.passData.newPswAgain;
  let mail = props.location.state.passData.mail;
  let phone = props.location.state.passData.phone;
  //let passUserPhone = props.location.state.passData.userPhone;


  const handleReloadCaptchaClick = React.useCallback(async () => {
    const data = await CaptchaCallService();
    setCaptchaResp(data);
    ConvertBase64ToImage(data);

  }, [])
  const [delay, setDelay] = useState(+"180"); 
  const minutes = Math.floor(delay / 60);
  const seconds = Math.floor(delay % 60);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setDelay(delay - 1);
    }, 1000);

    if (delay === 0) {

      clearInterval(timer);
      inputChange();
    }

    return () => {
      clearInterval(timer);
    };
  });
  useEffect(() => {
    //#region Captcha Call
    const fetchData = async () => {
      const data = await CaptchaCallService();
     
      setCaptchaResp(data);
      ConvertBase64ToImage(data);
    }

    fetchData();

    //#endregion

  }, []);

  const handleSubmit = React.useCallback(async (e, data) => {
    let userOtp = otp1 + otp2 + otp3 + otp4 + otp5 + otp6;
  
   
    responseSMSData = await CompositeOTPControl({  refInfo: passRefId,password: passCurrentPsw ,userId: passUserName,newpass:passNewPsw, userOtp: userOtp,param:0,id:"",entry:"",mail:mail,phone:phone });
   // smsOtpVerifyRespData = await sendSMSOTPVerify({ username: passUserName, referansId: passRefId, userOtp: userOtp });
   debugger; 
   if (responseSMSData.retCode === 0) {
      history.push("/sftp-changePassword-success")
      /*changePswRespData = await ChangePasswordService({ username: passUserName, currentPsw: passCurrentPsw, newPsw: passNewPsw, newPswAgain: passNewPswAgain });
      setChangeSrvRetCode(changePswRespData.ldapReturnCode)
      setChangeSrvRetMsg(changePswRespData.ldapReturnMessage)
     

     /* if (parseInt(changePswRespData.ldapReturnCode) === 0) {
       

      } else {
        setRetCode(parseInt(changePswRespData.ldapReturnCode))
        setreturnInfo(changePswRespData.ldapReturnMessage)
      }*/
debugger;
    } else if(responseSMSData.retCode === 99){    
      setRetCode(responseSMSData.retCode)
      setreturnInfo(responseSMSData.retMsg)
    }else{
       history.push("/sftp-changePassword-error");
    }


  }, [history, otp1, otp2, otp3, otp4, otp5, otp6, passRefId, passUserName, retCode, returnInfo, changeServiceRetCodes, changeServiceRetMsg, passCurrentPsw, passNewPsw, passNewPswAgain,mail,phone, t])

  const handleError = React.useCallback((e, errors) => {
    console.info(JSON.stringify(errors, void 0, 2))
  }, [])


  const handleReSendSms = React.useCallback(async () => {
    let userOtp = otp1 + otp2 + otp3 + otp4 + otp5 + otp6;
    responseSMSData = await CompositeOTPControl({  refInfo: passRefId,password: passCurrentPsw ,userId: passUserName,newpass:passNewPsw, userOtp: userOtp,param:1,id: captchaResp.id,entry:captchafield ,mail:mail,phone:phone});
  //  responseSMSData = await SendSMSOTPService({ username: passUserName, gsmNo: passUserPhone });
   // setreturnInfo(responseSMSData.retMsg)


    if (responseSMSData.retCode === 0) {

      const passData = { refId: responseSMSData.refId, userName: passUserName, currentPsw: passCurrentPsw, newPsw: passNewPsw, newPswAgain: passNewPswAgain, mail:mail,phone:phone };
      history.push('/sftp-changePassword-smsOtp', { passData });

    } else {
      setRetCode(responseSMSData.retCode);
      setreturnInfo(t(responseSMSData.retMsg));
    }

  }, [history, passUserName, passCurrentPsw, passNewPsw, passNewPswAgain, t,captchaResp.id , captchafield])

  const handleKeyDown = event => {
    const form = event.target.form;
    const index = Array.prototype.indexOf.call(form, event.target);
    if (event.key === 'Backspace') {

      if (index > 0) {
        form.elements[index - 1].focus();
      }
    }
    else if (event.key !== "delete") {
      if (index < 5) {
        form.elements[index + 1].focus();
      }
    }
  };

  const inputChange = () => {
    handleReloadCaptchaClick();
    setIsFormValid(true);
    setDelay(180);
  };

  const handleSendSms = React.useCallback(async () => {
    setIsFormValid(false);
    handleReSendSms();
    setDelay(180);
  }, [handleReSendSms])


  function ConvertBase64ToImage(respData) {
    setbase64Image(respData.base64Contents);
  }
  
  const handleChange = useCallback((e) => {

    const name = e.target.name
    const value = e.target.value

    switch (name) {
    case "securityCode":
      setcaptchafield(value)


    break;
    default:
    break;
    }
    }, [])

  const main = useMemo(() => {
    return (

      <Block className="bapp-page-login-main">
        <Block className="bapp-page-login-main-wrapper">
          <Element type="h1" style={{ fontSize: "24px", fontFamily: "Campton", textAlign: "center", fontWeight: "550" }}>{t("SMS entry")}</Element>
          <Element className="sftp-header" style={{ fontSize: "14px", fontFamily: "Campton", textAlign: "center", fontWeight: "475", lineHeight: "20px" }} >{t("Telefonunuza gelen 6 haneli kodu aşağıdaki alana girebilirsiniz.")}</Element>

          <Form onSubmit={handleSubmit} onError={handleError} grid={false}>

            <div style={{ width: "100%", marginTop: "25px" }}>
              <input className="akbankTextBox w3-col m2 floatLeft margin-5" type="text" name="otp1" onChange={(e) => { setotp1(e.target.value); }} onKeyUp={handleKeyDown} autoFocus={true} onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }} maxLength={1} />
              <input className="akbankTextBox w3-col m2 floatLeft margin-5" type="text" name="otp2" onChange={(e) => { setotp2(e.target.value); }} onKeyUp={handleKeyDown} onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }} maxLength={1} />
              <input className="akbankTextBox w3-col m2 floatLeft margin-5" type="text" name="otp3" onChange={(e) => { setotp3(e.target.value); }} onKeyUp={handleKeyDown} onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }} maxLength={1} />
              <input className="akbankTextBox w3-col m2 floatLeft margin-5" type="text" name="otp4" onChange={(e) => { setotp4(e.target.value); }} onKeyUp={handleKeyDown} onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }} maxLength={1} />
              <input className="akbankTextBox w3-col m2 floatLeft margin-5" type="text" name="otp5" onChange={(e) => { setotp5(e.target.value); }} onKeyUp={handleKeyDown} onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }} maxLength={1} />
              <input className="akbankTextBox w3-col m2 floatLeft margin-5" type="text" name="otp6" onChange={(e) => { setotp6(e.target.value); }} onKeyUp={handleKeyDown} onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }} maxLength={1} />
            </div>

            <Button text={t("Change Password")} type="submit" fullWidth />
            
            <div>
            {isFormValid &&
            <div style={{ display: "flex" }} onChange={handleChange}>
              <TextField 
                
                label={t("GÜVENLİK KODU")}
                placeholder={t("Güvenlik Kodun")}
                type="text"
                name="securityCode"
                validations={[required(t("validation.required"))]}
              />
              <span style={{ width: "30%", paddingTop: "13%" }}>
                <img src={"data:image/png;base64," + base64Image} width={"100%"} alt="Logo4" />
              </span>
              <span style={{ width: "10%", paddingTop: "13%" }}>
                <img src="../img/reload_icon.png" alt="logo" height={"40%"} onClick={handleReloadCaptchaClick} />
              </span>
          </div>
  }
            </div>
            
            <div>
              {isFormValid && <Link onClick={handleSendSms}  >{t("Tekrar Gönder")}</Link>}
              {!isFormValid && <Link disabled={true}  >{t("Tekrar Gönder (0" + minutes + ":" + (seconds <= 9 ? ("0" + seconds) : seconds) + ")")}</Link>}

            </div>
            <Link style={{ marginLeft: "10px" }} onClick={() => history.push("/")}>
              {t("Şifre İşlemleri")}
            </Link>

          </Form>
          {
            retCode !== 0 ? <p style={{ color: "#c81c27" }}><b>{returnInfo}</b></p> : ""
          }

        </Block>
      </Block>

    )
  }, [handleError, handleSubmit, t, retCode, returnInfo, handleSendSms, isFormValid, minutes, seconds, history,handleReloadCaptchaClick])

  return (
    <Page className="bapp-page-login" container={false} footer={false}>
      {size !== Sizes.xs ? (
        <>
          <Block className="" />
          <Block className="bapp-page-login-desktop-wrapper bapp-container">
            <Block>
              <BigLogoAkbank />

              <Image path={"/img/svg/mail-send.svg"} fallbackText={t("Oriented Woman")} />
              <Element className="sftp-header" style={{ fontSize: "34px", color: "black" }} type="h2" >{t("Your files are safe with the file sharing center")}</Element>
              <Element style={{ fontSize: "23px", color: "black" }}>{t("Akbank güvenli dosya transferi ile FTP dosyalarını güvenli bir şekilde aktarabilirsiniz.")} </Element>
            </Block>
            {main}
          </Block>
        </>
      ) : (
        main
      )}

    </Page>

  )
}

export default SftpChangePasswordSmsOtp
